module.exports = __webpack_public_path__ + "img/add.4e3bf522.svg";